// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  assetUrl: '/assets',
  // apiUrl: 'https://api.uniticexchange.com/api/v1/',
  // v2apiUrl: 'https://api.uniticexchange.com/api/v2/',
  // apiUrl: 'https://uniticdemoapi.clarisco.com/api/v1/',
  // v2apiUrl: 'https://uniticdemoapi.clarisco.com/api/v2/',

  apiUrlLocal: 'https://api.uniticexchange.com/api/v1/',
  apiUrl: 'https://api.uniticexchange.com/api/v1/',
  v2apiUrl: 'https://api.uniticexchange.com/api/v2/',
  v3apiUrl: 'https://api.uniticexchange.com/api/v3/',

  zeApiUrl: 'https://api.zecurechain.com/api/v1/',

  // apiUrlLocal: 'http://localhost:3004/api/v1/',
  // apiUrl: 'http://localhost:3004/api/v1/',
  // v2apiUrl: 'http://localhost:3004/api/v2/',
  // v3apiUrl: 'http://localhost:3004/api/v3/',

  // zeApiUrl: 'http://localhost:5000/api/v1/',

  enckey: 'U2FsdGVkX1+3j7f6aZ4h5r9Kqv4y7z4S'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
